<template>
  <aside>
    <div class="tw:flex tw:flex-col tw:gap-y-1 tw:mb-5">
      <h3 class="tw:text-xl tw:font-bold tw:text-gray-800">{{ $t('description_tips_header') }}</h3>
      <p class="tw:text-sm tw:text-gray-800">{{ $t('description_tips_subtext') }}</p>
    </div>

    <div class="tw:flex tw:flex-col tw:gap-3">
      <div
        v-for="(section, index) in sections"
        :key="index"
        class="tw:rounded-xl tw:border tw:border-gray-300 tw:bg-gray-100">
        <button
          :id="`property-description-sidebar-trigger-${index}`"
          type="button"
          class="tw:w-full tw:flex tw:items-center tw:justify-between tw:gap-2 tw:cursor-pointer tw:p-4"
          :aria-expanded="expandedIndex === index"
          :aria-controls="`property-description-sidebar-panel-${index}`"
          @click="toggle(index)">
          <span class="tw:font-bold tw:text-left">{{ $t(section.titleKey) }}</span>
          <ChevronDown
            class="tw:shrink-0 tw:transition-transform tw:duration-300 tw:w-3 tw:h-2"
            :class="expandedIndex === index ? 'tw:rotate-180' : ''"
            fill="none"
            stroke="currentColor"
          />
        </button>
        <div
          :id="`property-description-sidebar-panel-${index}`"
          role="region"
          class="tw:grid tw:transition-all tw:duration-300 tw:ease-in-out"
          :aria-labelledby="`property-description-sidebar-trigger-${index}`"
          :aria-hidden="expandedIndex !== index"
          :class="expandedIndex === index ? 'tw:grid-rows-[1fr]' : 'tw:grid-rows-[0fr]'">
          <div class="tw:overflow-hidden">
            <ul v-if="section.type === 'list'" class="tw:px-4 tw:pb-4 tw:text-sm tw:flex tw:flex-col tw:gap-2">
              <li v-for="item in section.items" :key="item.key" class="tw:flex tw:gap-2">
                <span
                  v-if="item.marker"
                  class="tw:shrink-0"
                  :class="item.marker === '+' ? 'tw:text-blue-700' : 'tw:text-red-700'"
                  aria-hidden="true">
                  {{ item.marker }}
                </span>
                <span>{{ $t(item.key) }}</span>
              </li>
            </ul>
            <p v-else-if="section.type === 'text'" class="tw:px-4 tw:pb-4 tw:text-sm" v-html="$t(section.contentKey)" />
          </div>
        </div>
      </div>
    </div>
    <p v-html="$t('profile_update_info_text')" class="tw:mt-4 tw:p-4 tw:text-xs tw:bg-gray-200 tw:rounded-xl"></p>
  </aside>
</template>

<script setup>
import { ref } from 'vue'

import ChevronDown from '@/components/icons/ChevronDown.svg?component'

const expandedIndex = ref(0)

const toggle = index => {
  expandedIndex.value = expandedIndex.value === index ? null : index
}

const sections = [
  {
    titleKey: 'description_guidelines_header',
    type: 'list',
    items: [
      { key: 'description_tip_1', marker: '+' },
      { key: 'description_tip_2', marker: '+' },
      { key: 'description_tip_3', marker: '+' },
      { key: 'description_tip_4', marker: '+' },
      { key: 'description_tip_5', marker: '+' },
      { key: 'description_tip_6', marker: '-' },
      { key: 'description_tip_7', marker: '-' },
      { key: 'description_tip_8', marker: '-' },
      { key: 'description_tip_9', marker: '-' },
    ],
  },
  {
    titleKey: 'description_translations_tip_header',
    type: 'text',
    contentKey: 'description_translation_tip',
  },
]
</script>
